import { FormattedMessage } from 'react-intl'
import { useState } from 'react'
import TutorialConnectorDialog from '@components/dialog/TutorialConnectorDialog/TutorialConnectorDialog'

import './TutorialConnectorButton.css'

export default function TutorialConnectorButton() {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      <button
        className="tutorial-button highlight-button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <FormattedMessage id="connectors-empty-list.button" />
      </button>
      <TutorialConnectorDialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  )
}
